import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import annotationPlugin from 'chartjs-plugin-annotation'

Chart.register(annotationPlugin)

document.addEventListener('DOMContentLoaded', function () {
	var healthSnapshots = document.querySelectorAll('.healthSnapshot .dataset')
	var healthPriorityDatas = document.querySelectorAll(
		'.healthPriority .dataset',
	)

	const COLORS = {
		black: '#000000',
		white: '#FFFFFF',
		loam: '#fff4ef',
		red: '#D87A85',
		green: '#4b7d40',
		gold: '#ecb31f',
		ponderosa: '#01341f',
		rust: '#a63f2b',
		green90: '#4b7d40E6',
		red90: '#D87A85E6',
		ponderosa40: '#01341f66',
	}

	const skipped = (ctx, value) =>
		ctx.p0.skip || ctx.p1.skip ? value : undefined

	const getOrCreateTooltip = chart => {
		let tooltipEl = chart.canvas.parentNode.querySelector('div')

		if (!tooltipEl) {
			tooltipEl = document.createElement('div')
			tooltipEl.classList.add('chart-tooltip')

			const table = document.createElement('table')
			table.style.margin = '0px'

			tooltipEl.appendChild(table)
			chart.canvas.parentNode.appendChild(tooltipEl)
		}

		return tooltipEl
	}

	healthSnapshots.forEach(dataSet => {
		var summary = dataSet.querySelector('.summary')
		let details = dataSet.querySelector('.more-details')
		if (details) {
			window.addEventListener('resize', () => {
				details.style.setProperty('--open-height', `auto`)
				details.style.setProperty(
					'--open-height',
					`${entry.target.scrollHeight}px`,
				)
			})
		}
		summary.addEventListener('click', () => {
			details.style.setProperty('--open-height', `${details.scrollHeight}px`)
			dataSet.classList.toggle('open')
			if (dataSet.classList.contains('open')) {
				summary.setAttribute('aria-expanded', 'true')
			} else {
				summary.setAttribute('aria-expanded', 'false')
			}
		})
		dataSet.addEventListener('click', () => {
			if (dataSet.dataset.beenOpened === 'false') {
				const redLines = new Image()
				redLines.src = '/assets/images/red_lines.png'
				redLines.onload = () => {
					dataSet.dataset.beenOpened = 'true'
					let chartElement = dataSet.querySelector('.chart-wrapper canvas')
					let chartData = JSON.parse(chartElement.dataset.chartData)

					const ctx = chartElement.getContext('2d')
					const fillPattern = ctx.createPattern(redLines, 'repeat')

					let keys = Object.keys(chartData)
					let labels = keys.map(key => key.replace('year', ''))
					let values = keys.map(
						key => Math.round(parseFloat(chartData[key]) * 10) / 10,
					)

					let targetVal =
						Math.round(parseFloat(chartElement.dataset.chartTargetValue) * 10) /
						10
					let maxValue = Math.max(...values.filter(value => !isNaN(value)))
					let maxY = maxValue > targetVal ? maxValue : targetVal
					maxY = maxY * 1.25
					maxY = Math.ceil(maxY)

					let targetVals = []
					let maxVals = []
					for (let i = 0; i < values.length; i++) {
						targetVals.push(targetVal)
						maxVals.push(maxY - targetVal)
					}
					let targetType = chartElement.dataset.chartTargetType

					let valueType = chartElement.dataset.chartValueType
					let populationParameter =
						chartElement.dataset.chartPopulationParameter

					// Build annotations
					let targetAnnotation = {
						type: 'label',
						xValue: -0.5,
						yValue: targetVal,
						content: function (value) {
							let content = 'Target - ' + targetVal
							if (valueType == 'percent') {
								content = content + '%'
							} else {
								content = content + ' per ' + populationParameter
							}
							content = content + ' or ' + targetType
							if (targetType == 'lower') {
								content = content + ' ↓'
							} else {
								content = content + ' ↑'
							}
							return content
						},
						color: COLORS.white,
						position: 'start',
						padding: 10,
						font: {
							family: 'Arboria, sans-serif',
							size:
								window.innerWidth >= 1536
									? 18
									: window.innerWidth >= 1200
										? 14
										: 12,
							weight: 500,
						},
					}
					let annotations = window.innerWidth >= 992 ? [targetAnnotation] : []
					for (let i = values.length - 1; i >= 0; i--) {
						if (Number.isNaN(values[i])) {
							let annotation = {
								type: 'label',
								xValue: i,
								yValue: 0,
								content: 'N/A',
								color: COLORS.loam,
								position: {
									x: 'center',
									y: 'end',
								},
								padding: 10,
								font: {
									family: 'Arboria, sans-serif',
									size:
										window.innerWidth >= 1536
											? 18
											: window.innerWidth >= 1200
												? 14
												: 12,
									weight: 500,
								},
							}
							annotations.push(annotation)
						} else {
							break
						}
					}

					const externalTooltipHandler = context => {
						// Tooltip Element
						const { chart, tooltip } = context
						const tooltipEl = getOrCreateTooltip(chart)

						// Hide if no tooltip
						if (tooltip.opacity === 0 || tooltip.body.length === 0) {
							tooltipEl.style.opacity = 0
							return
						}

						// Set Text
						if (tooltip.body) {
							const titleLines = tooltip.title || []
							const bodyLines = tooltip.body.map(b => b.lines)

							const tableHead = document.createElement('thead')

							titleLines.forEach(title => {
								const tr = document.createElement('tr')
								tr.style.borderWidth = 0

								const th = document.createElement('th')
								th.style.borderWidth = 0
								const text = document.createTextNode(title)

								th.appendChild(text)
								tr.appendChild(th)
								tableHead.appendChild(tr)
							})

							const tableBody = document.createElement('tbody')
							bodyLines.forEach((body, i) => {
								const tr = document.createElement('tr')
								tr.style.backgroundColor = 'inherit'
								tr.style.borderWidth = 0

								const td = document.createElement('td')
								td.style.borderWidth = 0

								let textContent = ''
								if (targetType === 'lower') {
									textContent =
										parseFloat(body) <= targetVal
											? 'Meets target'
											: 'Does not meet target'
								} else {
									textContent =
										parseFloat(body) >= targetVal
											? 'Meets target'
											: 'Does not meet target'
								}

								const text = document.createTextNode(textContent)

								td.appendChild(text)
								tr.appendChild(td)
								tableBody.appendChild(tr)
							})

							const tableRoot = tooltipEl.querySelector('table')

							// Remove old children
							while (tableRoot.firstChild) {
								tableRoot.firstChild.remove()
							}

							// Add new children
							tableRoot.appendChild(tableHead)
							tableRoot.appendChild(tableBody)
						}

						const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas

						// Display, position, and set styles for font
						tooltipEl.style.opacity = 1
						tooltipEl.style.left = positionX + tooltip.caretX + 'px'
						tooltipEl.style.top = positionY + tooltip.caretY + 'px'
					}

					new Chart(chartElement, {
						data: {
							labels: labels,
							datasets: [
								{
									type: 'line',
									data: values,
									pointStyle: 'circle',
									borderCapStyle: 'round',
									borderColor: COLORS.loam,
									backgroundColor: COLORS.loam,
									pointRadius: window.innerWidth >= 1200 ? 20 : 14,
									pointHoverBorderColor: COLORS.loam,
									pointHoverBackgroundColor: COLORS.loam,
									pointHoverRadius: window.innerWidth >= 1200 ? 20 : 14,
									segment: {
										borderDash: ctx => skipped(ctx, [10, 10]),
									},
									spanGaps: true,
									datalabels: {
										color: COLORS.ponderosa,
										formatter: function (value, context) {
											if (valueType == 'percent') {
												return value + '%'
											} else {
												return value
											}
										},
										font: {
											family: 'Arboria, sans-serif',
											size: window.innerWidth >= 1200 ? 12 : 10,
											weight: '700',
										},
									},
								},
								{
									type: 'bar',
									data: targetVals,
									barPercentage: 1,
									categoryPercentage: 1,
									pointHitRadius: 0,
									backgroundColor:
										targetType == 'lower' ? COLORS.green90 : fillPattern,
									hoverBackgroundColor:
										targetType == 'lower' ? COLORS.green90 : fillPattern,
									datalabels: {
										display: false,
									},
								},
								{
									type: 'bar',
									data: maxVals,
									barPercentage: 1,
									categoryPercentage: 1,
									pointHitRadius: 0,
									backgroundColor:
										targetType == 'lower' ? fillPattern : COLORS.green90,
									hoverBackgroundColor:
										targetType == 'lower' ? fillPattern : COLORS.green90,
									datalabels: {
										display: false,
									},
								},
							],
						},
						options: {
							animation: {
								duration: 0,
							},
							responsive: true,
							maintainAspectRatio: false,
							scales: {
								x: {
									stacked: true,
									backgroundColor: COLORS.ponderosa,
									grid: {
										lineWidth: 0,
									},
									ticks: {
										color: COLORS.loam,
										font: {
											family: 'Arboria, sans-serif',
											size:
												window.innerWidth >= 1536
													? 16
													: window.innerWidth >= 1200
														? 14
														: 12,
											weight: 700,
										},
										padding: 15,
									},
								},
								y: {
									stacked: true,
									max: maxY,
									grid: {
										color: COLORS.black,
										tickLength: 0,
									},
									ticks: {
										display: false,
										maxTicksLimit: 6,
									},
								},
							},
							layout: {
								autoPadding: false,
							},
							interaction: {
								intersect: false,
								mode: 'index',
							},
							plugins: {
								legend: {
									display: false,
								},
								tooltip: {
									enabled: false,
									filter: function (tooltipItem) {
										return tooltipItem.datasetIndex === 0
									},
									external: externalTooltipHandler,
								},
								annotation: {
									annotations: annotations,
								},
							},
							onResize: function (chart, size) {
								// Update annotations
								if (window.innerWidth >= 992) {
									// Check if our "target" annotation does not exist (it will always be the first, and is the only one with this xValue)
									if (annotations[0]) {
										if (annotations[0].xValue != -0.5) {
											annotations.unshift(targetAnnotation)
										}
									} else {
										annotations.unshift(targetAnnotation)
									}
								} else {
									if (annotations[0]) {
										if (annotations[0].xValue == -0.5) {
											annotations.shift()
										}
									}
								}
								// Update annotation font sizes based on chart size
								if (size.width >= 800) {
									annotations.forEach(annotation => {
										annotation.font.size = 18
									})
								} else if (size.width >= 700) {
									annotations.forEach(annotation => {
										annotation.font.size = 16
									})
								} else if (size.width >= 600) {
									annotations.forEach(annotation => {
										annotation.font.size = 14
									})
								} else {
									annotations.forEach(annotation => {
										annotation.font.size = 12
									})
								}
								// Update tick font sizes based on window size
								if (window.innerWidth >= 1536) {
									chart.options.scales.x.ticks.font.size = 16
								} else if (window.innerWidth >= 1200) {
									chart.options.scales.x.ticks.font.size = 14
								} else {
									chart.options.scales.x.ticks.font.size = 12
								}
								// Dataset point and border sizes
								if (window.innerWidth >= 1200) {
									chart.data.datasets[0].pointRadius = 20
									chart.data.datasets[0].pointHoverRadius = 20
									// DO NOT use rem for font size
									// It breaks the datalabels, for some reason
									chart.data.datasets[0].datalabels.font.size = 12
								} else {
									chart.data.datasets[0].pointRadius = 14
									chart.data.datasets[0].pointHoverRadius = 14
									// DO NOT use rem for font size
									// It breaks the datalabels, for some reason
									chart.data.datasets[0].datalabels.font.size = 10
								}
							},
						},
						plugins: [ChartDataLabels],
					})
				}
			}
		})
	})

	healthPriorityDatas.forEach(dataSet => {
		let summary = dataSet.querySelector('.summary')
		let details = dataSet.querySelector('.more-details')
		if (details) {
			window.addEventListener('resize', () => {
				details.style.setProperty('--open-height', `auto`)
				details.style.setProperty('--open-height', `${details.scrollHeight}px`)
			})
		}
		summary.addEventListener('click', () => {
			details.style.setProperty('--open-height', `${details.scrollHeight}px`)
			dataSet.classList.toggle('open')
			if (dataSet.classList.contains('open')) {
				summary.setAttribute('aria-expanded', 'true')
			} else {
				summary.setAttribute('aria-expanded', 'false')
			}
		})
		dataSet.addEventListener('click', () => {
			if (dataSet.dataset.beenOpened === 'false') {
				dataSet.dataset.beenOpened = 'true'
				let chartElement = dataSet.querySelector('.chart-wrapper canvas')
				let whitmanData = JSON.parse(chartElement.dataset.whitmanData)
				let washingtonData = JSON.parse(chartElement.dataset.washingtonData)
				let targetType = JSON.parse(chartElement.dataset.targetType)

				let keys = Object.keys(whitmanData)
				let labels = keys.map(key => key.replace('year', ''))
				let whitmanValues = keys.map(
					key => Math.round(parseFloat(whitmanData[key]) * 10) / 10,
				)
				let washingtonValues = keys.map(
					key => Math.round(parseFloat(washingtonData[key]) * 10) / 10,
				)
				let allValuesNoNan = [
					...whitmanValues.filter(x => x),
					...washingtonValues.filter(x => x),
				]
				let minVal = Math.min(...allValuesNoNan)
				let maxVal = Math.max(...allValuesNoNan)
				let range = maxVal - minVal

				let valueType = chartElement.dataset.chartValueType

				let datasetColors = [COLORS.green, COLORS.gold]

				let lastTickIndex = -1

				const externalTooltipHandler = context => {
					// Tooltip Element
					const { chart, tooltip } = context
					const tooltipEl = getOrCreateTooltip(chart)

					// Hide if no tooltip
					if (tooltip.opacity === 0 || tooltip.body.length === 0) {
						tooltipEl.style.opacity = 0
						return
					}

					// Set Text
					if (tooltip.body) {
						const titleLines = tooltip.title || []
						const bodyLines = tooltip.body.map(b => b.lines)

						const tableHead = document.createElement('thead')

						titleLines.forEach(title => {
							const tr = document.createElement('tr')
							tr.style.borderWidth = 0

							const th = document.createElement('th')
							th.style.borderWidth = 0
							const text = document.createTextNode(title)

							th.appendChild(text)
							tr.appendChild(th)
							tableHead.appendChild(tr)
						})

						const tableBody = document.createElement('tbody')
						// Determine if data is missing for one set, and slot it in where applicable
						if (bodyLines.length < 2) {
							if (bodyLines[0][0].includes('Washington State')) {
								bodyLines.unshift(['Whitman County: N/A'])
							} else {
								bodyLines.push(['Washington State: N/A'])
							}
						}
						bodyLines.forEach((body, i) => {
							const span = document.createElement('span')
							span.style.background = datasetColors[i]
							span.style.borderColor = datasetColors[i]
							span.style.borderWidth = '0.125rem'
							span.style.marginRight = '0.75rem'
							span.style.height = '0.75rem'
							span.style.width = '0.75rem'
							span.style.display = 'inline-block'

							const tr = document.createElement('tr')
							tr.style.backgroundColor = 'inherit'
							tr.style.borderWidth = 0

							const td = document.createElement('td')
							td.style.borderWidth = 0

							if (!body[0].includes('N/A') && valueType == 'percent') {
								body = body + '%'
							}
							const text = document.createTextNode(body)

							td.appendChild(span)
							td.appendChild(text)
							tr.appendChild(td)
							tableBody.appendChild(tr)
						})

						const tableRoot = tooltipEl.querySelector('table')

						// Remove old children
						while (tableRoot.firstChild) {
							tableRoot.firstChild.remove()
						}

						// Add new children
						tableRoot.appendChild(tableHead)
						tableRoot.appendChild(tableBody)
					}

					const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas

					// Display, position, and set styles for font
					tooltipEl.style.opacity = 1
					tooltipEl.style.left = positionX + tooltip.caretX + 'px'
					tooltipEl.style.top = positionY + tooltip.caretY + 'px'
					tooltipEl.style.padding =
						tooltip.options.padding + 'px ' + tooltip.options.padding + 'px'
				}

				new Chart(chartElement, {
					data: {
						labels: labels,
						datasets: [
							{
								type: 'line',
								label: 'Whitman County',
								data: whitmanValues,
								pointStyle: 'circle',
								borderCapStyle: 'round',
								borderWidth: window.innerWidth >= 1200 ? 8 : 4,
								borderColor: datasetColors[0],
								backgroundColor: datasetColors[0],
								pointRadius: window.innerWidth >= 1200 ? 8 : 4,
								pointHoverBorderColor: datasetColors[0],
								pointHoverBackgroundColor: datasetColors[0],
								pointHoverRadius: window.innerWidth >= 1200 ? 8 : 4,
								pointHoverBorderWidth: window.innerWidth >= 1200 ? 8 : 4,
								segment: {
									borderDash: ctx => skipped(ctx, [16, 16]),
								},
								spanGaps: true,
							},
							{
								type: 'line',
								label: 'Washington State',
								data: washingtonValues,
								pointStyle: 'circle',
								borderCapStyle: 'round',
								borderWidth: window.innerWidth >= 1200 ? 8 : 4,
								borderColor: datasetColors[1],
								backgroundColor: datasetColors[1],
								pointRadius: window.innerWidth >= 1200 ? 8 : 4,
								pointHoverBorderColor: datasetColors[1],
								pointHoverBackgroundColor: datasetColors[1],
								pointHoverRadius: window.innerWidth >= 1200 ? 8 : 4,
								pointHoverBorderWidth: window.innerWidth >= 1200 ? 8 : 4,
								segment: {
									borderDash: ctx => skipped(ctx, [16, 16]),
								},
								spanGaps: true,
							},
						],
					},
					options: {
						animation: {
							duration: 0,
						},
						responsive: true,
						maintainAspectRatio: false,
						scales: {
							x: {
								grid: {
									lineWidth: 0,
								},
								ticks: {
									color: COLORS.ponderosa,
									font: {
										family: 'Arboria, sans-serif',
										size:
											window.innerWidth >= 1536
												? 16
												: window.innerWidth >= 1200
													? 14
													: 12,
										weight: 700,
									},
									padding: 15,
								},
							},
							y: {
								suggestedMin: minVal - range / 3,
								suggestedMax: maxVal + range / 3,
								grid: {
									color: function (context) {
										const index = context.index
										if (
											(index === 0 && targetType === 'higher') ||
											(index === lastTickIndex && targetType === 'lower')
										) {
											return COLORS.rust
										}
										if (
											(index === 0 && targetType === 'lower') ||
											(index === lastTickIndex && targetType === 'higher')
										) {
											return COLORS.green
										}
										return COLORS.ponderosa
									},
									tickLength: 0,
								},
								afterBuildTicks: function (scale) {
									// This runs after ticks are built
									lastTickIndex = scale.ticks.length - 1
									return scale.ticks
								},
								ticks: {
									color: function (context) {
										const index = context.index
										if (
											(index === 0 && targetType === 'higher') ||
											(index === lastTickIndex && targetType === 'lower')
										) {
											return COLORS.rust
										}
										if (
											(index === 0 && targetType === 'lower') ||
											(index === lastTickIndex && targetType === 'higher')
										) {
											return COLORS.green
										}
										return COLORS.ponderosa
									},
									font: {
										family: 'Arboria, sans-serif',
										size:
											window.innerWidth >= 1536
												? 16
												: window.innerWidth >= 1200
													? 14
													: 12,
										weight: 700,
									},
									padding: 15,
									maxTicksLimit: 6,
									// Include a % if valueType is percent
									callback: function (value, index, ticks) {
										if (valueType == 'percent') {
											return value + '%'
										} else {
											return value
										}
									},
								},
							},
						},
						interaction: {
							intersect: false,
							mode: 'index',
						},
						plugins: {
							legend: {
								display: false,
							},
							tooltip: {
								enabled: false,
								external: externalTooltipHandler,
							},
						},
						onResize: function (chart, size) {
							// Update tick font sizes based on window size
							if (window.innerWidth >= 1536) {
								chart.options.scales.x.ticks.font.size = 16
								chart.options.scales.y.ticks.font.size = 16
							} else if (window.innerWidth >= 1200) {
								chart.options.scales.x.ticks.font.size = 14
								chart.options.scales.y.ticks.font.size = 14
							} else {
								chart.options.scales.x.ticks.font.size = 12
								chart.options.scales.y.ticks.font.size = 12
							}
							// Dataset point and border sizes
							if (window.innerWidth >= 1200) {
								chart.data.datasets[0].borderWidth = 8
								chart.data.datasets[0].pointRadius = 8
								chart.data.datasets[0].pointHoverRadius = 8
								chart.data.datasets[0].pointHoverBorderWidth = 8
								chart.data.datasets[1].borderWidth = 8
								chart.data.datasets[1].pointRadius = 8
								chart.data.datasets[1].pointHoverRadius = 8
								chart.data.datasets[1].pointHoverBorderWidth = 8
							} else {
								chart.data.datasets[0].borderWidth = 4
								chart.data.datasets[0].pointRadius = 4
								chart.data.datasets[0].pointHoverRadius = 4
								chart.data.datasets[0].pointHoverBorderWidth = 4
								chart.data.datasets[1].borderWidth = 4
								chart.data.datasets[1].pointRadius = 4
								chart.data.datasets[1].pointHoverRadius = 4
								chart.data.datasets[1].pointHoverBorderWidth = 4
							}
						},
					},
				})
			}
		})
	})

	// Filter buttons
	var dataGroups = document.querySelectorAll('.data-dashboard-data-group')
	dataGroups.forEach(dataGroup => {
		var filterButtons = dataGroup.querySelectorAll('button')
		var groups = dataGroup.querySelectorAll('.data-dashboard-data-subgroup')

		filterButtons.forEach(filterButton => {
			filterButton.addEventListener('click', () => {
				filterButtons.forEach(filterButton => {
					filterButton.classList.remove('selected')
				})
				filterButton.classList.add('selected')

				groups.forEach(group => {
					if (
						group.dataset.group == filterButton.dataset.group ||
						filterButton.dataset.group == 'all'
					) {
						group.classList.remove('hidden')
					} else {
						group.classList.add('hidden')
					}
				})
			})
		})
	})
})
